import React, {FC} from 'react';

import {Trans} from '../../libs/shared/helpers/src/internationalization/react';
import {Renderer} from '../../libs/shared/helpers/src/react/reactHelpers';
import {FutureTimeValueModel, FutureTimeValuesEnum} from '../../src/models/api/futureTimeValueModel';

/*
 * Props.
 */

interface FutureTimeFormatterProps {
  value: FutureTimeValueModel;
}

/*
 * Component.
 */

export const FutureTimeFormatter: FC<FutureTimeFormatterProps> = ({value}) => (
  <>{futureTimeRenderers[value]()}</>
);

/*
 * Localization map.
 */

type FutureTimeRenderers = {[T in FutureTimeValuesEnum]: Renderer};
// prettier-ignore
const futureTimeRenderers: FutureTimeRenderers = {
  [FutureTimeValuesEnum.ADD_2_MINUTES]: () => <Trans id="reminder-add-2-minutes">2 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_10_MINUTES]: () => <Trans id="reminder-add-10-minutes">10 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_20_MINUTES]: () => <Trans id="reminder-add-20-minutes">20 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_30_MINUTES]: () => <Trans id="reminder-add-30-minutes">30 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_40_MINUTES]: () => <Trans id="reminder-add-40-minutes">40 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_50_MINUTES]: () => <Trans id="reminder-add-50-minutes">50 minutes</Trans>,
  [FutureTimeValuesEnum.ADD_1_HOUR]: () => <Trans id="reminder-add-1-hour">1 hour</Trans>,
  [FutureTimeValuesEnum.ADD_1_HOUR_HALF]: () => <Trans id="reminder-add-1-30">1 hour and a half</Trans>,
  [FutureTimeValuesEnum.ADD_2_HOURS]: () => <Trans id="reminder-add-2-hours">2 hours</Trans>,
  [FutureTimeValuesEnum.ADD_3_HOURS]: () => <Trans id="reminder-add-3-hours">3 hours</Trans>,
  [FutureTimeValuesEnum.ADD_4_HOURS]: () => <Trans id="reminder-add-4-hours">4 hours</Trans>,
  [FutureTimeValuesEnum.ADD_5_HOURS]: () => <Trans id="reminder-add-5-hours">5 hours</Trans>,
  [FutureTimeValuesEnum.ADD_6_HOURS]: () => <Trans id="reminder-add-6-hours">6 hours</Trans>,
  [FutureTimeValuesEnum.ADD_8_HOURS]: () => <Trans id="reminder-add-8-hours">8 hours</Trans>,
  [FutureTimeValuesEnum.ADD_10_HOURS]: () => <Trans id="reminder-add-10-hours">10 hours</Trans>,
  [FutureTimeValuesEnum.ADD_12_HOURS]: () => <Trans id="reminder-add-12-hours">12 hours</Trans>,
  [FutureTimeValuesEnum.TOMORROW_9AM]: () => <Trans id="reminder-tomorrow-9-am">Tomorrow 9am</Trans>,
  [FutureTimeValuesEnum.TOMORROW_2PM]: () => <Trans id="reminder-tomorrow-2-pm">Tomorrow 2pm</Trans>,
  [FutureTimeValuesEnum.ADD_2_DAYS]: () => <Trans id="reminder-add-2-days">2 days</Trans>,
  [FutureTimeValuesEnum.ADD_3_DAYS]: () => <Trans id="reminder-add-3-days">3 days</Trans>,
  [FutureTimeValuesEnum.ADD_4_DAYS]: () => <Trans id="reminder-add-4-days">4 days</Trans>,
  [FutureTimeValuesEnum.ADD_5_DAYS]: () => <Trans id="reminder-add-5-days">5 days</Trans>,
  [FutureTimeValuesEnum.ADD_6_DAYS]: () => <Trans id="reminder-add-6-days">6 days</Trans>,
  [FutureTimeValuesEnum.ADD_1_WEEK]: () => <Trans id="reminder-add-1-week">1 week</Trans>,
  [FutureTimeValuesEnum.ADD_10_DAYS]: () => <Trans id="reminder-add-10-days">10 days</Trans>,
  [FutureTimeValuesEnum.ADD_2_WEEKS]: () => <Trans id="reminder-add-2-weeks">2 weeks</Trans>,
  [FutureTimeValuesEnum.ADD_3_WEEKS]: () => <Trans id="reminder-add-3-weeks">3 weeks</Trans>,
  [FutureTimeValuesEnum.ADD_1_MONTH]: () => <Trans id="reminder-add-1-month">1 month</Trans>,
  [FutureTimeValuesEnum.ADD_2_MONTHS]: () => <Trans id="reminder-add-2-months">2 months</Trans>,
  [FutureTimeValuesEnum.ADD_3_MONTHS]: () => <Trans id="reminder-add-3-months">3 months</Trans>
};
